









































































































































import Vue from 'vue';
import axios from 'axios';
import io from 'socket.io-client';
import { mapActions, mapState } from 'vuex';
import userService from '@/services/hub/user';
import Helpers from '@/utils/Helpers';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';
import AppHeader from '../components/AppHeader.vue';
import NewEventsTable from '../components/EventsTable/NewEventsTable.vue';
import {
  HubHeading,
  HubSelect,
  HubInput,
  HubIcon,
  HubModal,
  HubDatePicker,
  HubButton,
  HubTimePicker,
  HubPagination,
} from '../components/HubComponents';

export default Vue.extend({
  name: 'ViewEvents',
  components: {
    AppHeader,
    NewEventsTable,
    HubHeading,
    HubSelect,
    HubInput,
    HubIcon,
    HubModal,
    HubDatePicker,
    HubButton,
    HubTimePicker,
    HubPagination,
  },
  data() {
    return {
      filters: [
        { text: this.$t('all'), value: '' },
        { text: this.$t('scheduled'), value: 'WAITING_LIVE' },
        { text: this.$t('live'), value: 'LIVE' },
        { text: this.$t('finished'), value: 'ON_DEMAND' },
      ],

      selectFilter: '',
      search: '',

      actualPage: 1,
      eventsPageLength: 5,
      eventsPageQuantity: 0,

      eventTitle: '',
      eventDate: new Date().toISOString().substr(0, 10),
      eventSchedule: '',
      folder: '',
      folders: [
        'Pasta Evento Janeiro',
        'Pasta Evento Fevereiro',
        'Pasta Evento Março',
        'Pasta Evento Abril',
      ],

      orderType: 'desc',
      rules: {
        required: (value: string) => !!value.trim() || this.$t('required_field'),
      },
      newEventModalOpen: false,
      eventsTable: 0 as number,
      timeOutId: 0 as unknown as NodeJS.Timeout,
      openDropdown: false,
      interval: null as number | null,
      value: 0,
      conversionsProgress: {} as any,
      queueVideos: 0 as any,
      isDragging: false,
      fileInputPlaceholder: 'drag_and_drop_a_video_file_here_or_click_to_select' as any,
      fileInputValue: [],
      activeTab: null,
      tableHeaders: [
        { text: '', value: '' },
        { text: 'name', value: 'name' },
        { text: 'duration', value: 'duration' },
        { text: 'send_date', value: 'send_date' },
        { text: 'size', value: 'size' },
        { text: ' ', value: '' },
      ],
      smTableHeaders: [
        { text: '', value: '' },
        { text: 'name', value: 'name' },
        { text: 'size', value: 'size' },
        { text: '  ', value: '' },
      ],
      allVideos: [] as any,

      remainingVideos: 0 as any,
      listVideoConversion: [] as any,
      errorSocket: [] as any,
      failedSocket: [] as any,
      completedSocket: null,
      socket: null as any,
      listVideoConversionTest: [] as any,
      customerPlansId: 0 as any,
      secretPlayer: '',
      playerCopy: false,
      planOdId: 0,
      userToken: '',
      id_customer: 0,
      username: '',
    };
  },
  computed: mapState(['user', 'events', 'secret']),
  watch: {
    actualPage() {
      this.fetchEvents();
    },
    orderType(): void {
      this.fetchEvents();
    },
    search(): void {
      this.actualPage = 1;

      clearTimeout(this.timeOutId);
      this.timeOutId = setTimeout(() => {
        this.fetchEvents();
      }, 500);
    },
    selectFilter(): void {
      this.actualPage = 1;

      this.fetchEvents();
    },
  },
  beforeDestroy() {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
  },
  async mounted() {
    await this.userInformation();
    this.fetchEvents();
    setInterval(() => {
      if (this.value === 100) {
        this.value = 0;
      }
      this.value += 10;
      return undefined;
    }, 1000);
  },
  methods: {
    ...mapActions({
      loadEvents: 'events/loadEvents',
      createEvent: 'events/createEvent',
    }),
    async userInformation() {
      const userInfo = localStorage.getItem('user') as any;
      const user = JSON.parse(userInfo);

      const { token } = user;
      const decodedToken = jwtDecode(token) as any;
      this.username = decodedToken.sub.nickname;
      this.id_customer = decodedToken.sub.id_customers;
      this.customerPlansId = user.user.plan_id;
      this.userToken = user.token;
      await this.getPlanOd(this.customerPlansId);
      await this.getCustomerPlan(this.planOdId);
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao registrar o log:', error);
      }
    },
    async fetchEvents(): Promise<any> {
      const title = this.search.trim() !== '' ? this.search.trim() : false;
      const status = this.selectFilter !== '' ? this.selectFilter : false;

      let loadEvents = {
        planId: this.user.planId,
        actualPage: this.actualPage,
        quantity: this.eventsPageLength,
        orderBy: 'date',
        orderType: this.orderType,
      };

      loadEvents = title ? { ...loadEvents, ...{ title } } : loadEvents;
      loadEvents = status ? { ...loadEvents, ...{ status } } : loadEvents;

      await this.loadEvents(loadEvents);
      this.eventsPageQuantity = Math.ceil(this.events.total / this.eventsPageLength);
      this.eventsTable += 1;
    },
    next() {
      this.createEvent({
        planId: this.user.planId,
        title: this.eventTitle,
        dateScheduled: `${this.eventDate} ${this.eventSchedule}`,
      }).then(async (newEvent) => {
        const logDescription = `Evento criado: ${this.eventTitle} com hash: ${newEvent.event_hash}`;
        await this.logUserAction('Creation', 'Success', logDescription);

        this.$router.push({ path: `event/${newEvent.event_hash}` });
      }).catch(async (error) => {
        const logDescription = `Erro ao criar evento: ${this.eventTitle}`;

        await this.logUserAction('Creation', 'Error', logDescription);

        console.error('Erro ao criar o evento:', error);
      });
    },
    showToast(key: string, type: string) {
      const text = this.$t(key);
      this.$store.dispatch('notification/create', {
        text,
        type,
      });
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.secretPlayer = response.data.data.secret;
    },
    // eslint-disable-next-line consistent-return
    formatTime(time: any) {
      if (typeof time === 'string') {
        const date = time;
        return date.split('.')[0];
      }
    },

    onClickVisualize(hash: string) {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${hash}`;
      window.open(videoUrl, '_blank');
    },
    async onClickCopyIframe(hash: string, autoplay: any) {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${hash}`;
      const iframeCode = String.prototype.concat(
        '<iframe ',
        `allow="${autoplay}" `,
        'allowfullscreen ',
        'class="jmvplayer" ',
        'frameborder="0" ',
        `src="${videoUrl}" `,
        'width="640" height="360"></iframe>',
      );

      try {
        await Helpers.copyToClipboard(iframeCode);
        const index = this.allVideos.findIndex((video: any) => video.hash === hash);
        if (index !== -1) {
          this.$set(this.allVideos, index, { ...this.allVideos[index], showCopySuccess: true });
          setTimeout(() => {
            this.$set(this.allVideos, index,
              { ...this.allVideos[index], showCopySuccess: false });
          }, 3000);
        }
        this.showToast('iframe_copied_successfully', 'success');
      } catch (error) {
        console.error(`Erro ao copiar para a área de transferência: ${error.message}`);
        this.showToast('error_copying_to_clipboard', 'error');
      }
    },
    async getPlanOd(eventId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${eventId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
});
